// 表单数据
export const formData = {
  infoType: '',
  code: '',
  content: '',
  creationTime: '',
  creator: '',
  id: '',
  name: '',
};

// 表单验证规则
export const formRules = {
  name: [
    {
      required: true,
      message: '隐私条例名称不能为空',
      trigger: 'blur',
    },
  ],
  infoType: [{ required: true, message: '位置不能为空', trigger: 'blur' }],
  // answer_analyze: [
  //   { required: true, message: '隐私条例内容不能为空', trigger: 'blur' },
  // ],
};
